import React, { createContext, useContext } from 'react';
import { useCurrency, UseCurrencyReturn, CurrencyInfo } from '../hooks/useCurrency';
const CurrencyContext = createContext<UseCurrencyReturn>({
  loading: true,
  currency: {
    code: 'USD',
    symbol: '$',
    rate: 1
  },
  formatPrice: (usd: number) => `$${usd.toFixed(2)}`
});
export function CurrencyProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const value = useCurrency();
  return <CurrencyContext.Provider value={value} data-id="element-184">
      {children}
    </CurrencyContext.Provider>;
}
export function useCurrencyContext(): UseCurrencyReturn {
  return useContext(CurrencyContext);
}